<template>
  <div class="blog-posts-page posts">
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4"
    >
      <h1 class="mr-2">{{ $route.params.pageSlug }} page reviews</h1>
      <div class="d-flex">
        <button
          class="btn btn-primary mr-4"
          @click="$router.push('/reviews/new/' + $route.params.pageSlug)"
        >
          <b>Add Review</b>
        </button>
        <button
          type="button"
          class="btn btn-secondary expand-all d-flex align-items-center"
          @click="expand = !expand"
        >
          <div :class="[!expand ? 'expand-icon' : 'compress-icon']" />
        </button>
      </div>
    </div>
    <div v-if="reviews && reviews.length" class="row">
      <div v-for="review in reviews" :key="review.id" class="col-md-3 mb-3">
        <div
          class="bg-white p-3 rounded review-card"
          :class="!expand ? 'expand' : ''"
        >
          <div class="d-flex flex-column">
            <span
              >Email: <strong> {{ review.email }}</strong></span
            >
            <span
              >Name: <strong> {{ review.name }}</strong></span
            >
            <span
              >Title: <strong> {{ review.title }}</strong></span
            >
            <span :title="review.review" class="pointer"
              >Review: <strong> {{ review.review }}</strong></span
            >
            <span
              >Rating: <strong> {{ review.rating }}</strong></span
            >
          </div>
          <div class="d-flex justify-content-end options-buttons mt-3">
            <button
              class="btn btn-secondary d-flex align-items-center justify-content-center mr-2"
              style="cursor: default"
            >
              <input
                type="checkbox"
                class="pointer"
                v-model="review.status"
                @change="updateReview(review)"
              />
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              @click="deleteReview(review.id)"
            >
              <i class="fa fa-trash text-danger"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="reviews && !reviews.length && !reviewsLoading" class="claims">
      No reviews added.
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "PageReviews",
  data: () => ({
    reviews: [],
    reviewsLoading: false,
    expand: false
  }),
  mounted() {
    this.getReviews();
  },
  methods: {
    getReviews() {
      this.reviewsLoading = true;
      axios
        .get("/reviews/" + this.$route.params.pageSlug)
        .then(resp => {
          this.reviews = resp.data.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.reviewsLoading = false;
        });
    },
    updateReview(review) {
      axios
        .patch(`/reviews/${review.id}`, { ...review })
        .then(() => {
          this.getReviews();
          this.$vToastify.success("Review updated.");
        })
        .catch(error => {
          console.log(error);
          this.$vToastify.error(error.message, "Error");
        });
    },
    deleteReview(reviewId) {
      axios
        .delete(`/reviews/${reviewId}`)
        .then(() => {
          this.getReviews();
          this.$vToastify.success("Review deleted.");
        })
        .catch(error => {
          this.$vToastify.error(error.message, "Error");
        });
    }
  }
};
</script>
<style scoped>
/* Card Style */
.review-card {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.review-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.review-card .d-flex span {
  color: #374151;
  font-weight: 500;
  font-size: 0.9rem;
  margin-bottom: 0.4rem;
}

.review-card .pointer {
  cursor: pointer;
  color: #2563eb;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.review-card .pointer:hover {
  color: #1d4ed8;
}

/* Button Styles within Cards */
.options-buttons .btn {
  padding: 0.4rem 0.8rem;
  border-radius: 0.375rem;
  font-size: 0.85rem;
  font-weight: 600;
  transition: background-color 0.2s ease, transform 0.1s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  margin-left: 0.5rem;
}

/* Update (Checkbox) Button */
.options-buttons .btn-secondary {
  background-color: #e5e7eb;
  color: #374151;
  border: 1px solid #d1d5db;
}

.options-buttons .btn-secondary:hover {
  background-color: #d1d5db;
  transform: translateY(-2px);
}

.options-buttons .btn-secondary:active {
  background-color: #9ca3af;
  transform: translateY(1px);
}

/* Delete Button */
.options-buttons .delete-btn {
  background-color: transparent;
  color: #ef4444;
  font-size: 1.2rem;
}

.options-buttons .delete-btn:hover {
  color: #dc2626;
  transform: scale(1.1);
}

.options-buttons .delete-btn:active {
  color: #b91c1c;
  transform: scale(1);
}

/* Card Expand Style */
.expand span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
